import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaUser, FaTools, FaGreaterThan, FaPlay, FaSave, FaRedo, FaUsers, FaCogs, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import Ajouter_acces from './ajouter_acces';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import axios from 'axios';
import { getAuthToken } from '../../../authToken';

// Composant Modal pour ajouter un groupe
// Composant Modal pour ajouter un groupe
const AjouterGroupeModal = ({ show, onHide, onSuccess, userId }) => {
    const [formData, setFormData] = useState({
        nom: '',
        description: '',
        type_groupe: 'Cohorte',
        nbre_apprenant: 0,
        specialite_id: '',      // ⬅ AJOUT
    });
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // ⬇ Chargement des spécialités
    const [specialites, setSpecialites] = useState([]);
    const [isLoadingSpecialites, setIsLoadingSpecialites] = useState(false);

    useEffect(() => {
        if (!show) return;   // ne charge que quand la modale s'ouvre

        const fetchSpecialites = async () => {
            setIsLoadingSpecialites(true);
            try {
                const token = localStorage.getItem('access_token');
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/liste-specialite/?per_page=100`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    setSpecialites(data.liste_spe || []);
                } else {
                    console.error('Erreur chargement produits');
                }
            } catch (error) {
                console.error('Erreur réseau produits:', error);
            } finally {
                setIsLoadingSpecialites(false);
            }
        };

        fetchSpecialites();
    }, [show]);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // ---- Validation ----
        if (!formData.nom) {
            showAlert("Le nom est obligatoire.", "danger");
            return;
        }
        if (!formData.nbre_apprenant) {
            showAlert("Le nombre d'apprenants est obligatoire.", "danger");
            return;
        }
        if (!formData.specialite_id) {
            showAlert("La spécialité est obligatoire.", "danger");
            return;
        }

        setIsSubmitting(true);

        const data = {
            nom: formData.nom,
            description: formData.description,
            type_groupe: formData.type_groupe,
            nbre_apprenant: formData.nbre_apprenant,
            specialite_id: formData.specialite_id,      // ⬅ AJOUT
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_HOTE + `/ajouter-groupe/${userId}/`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                }
            );

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                showAlert(errorData.error || "Erreur lors de la création du groupe.", "danger");
            } else {
                const responseData = await response.json();
                console.log('Succès:', responseData);
                showAlert("Groupe créé avec succès !", "success");
                resetForm();
                onSuccess();
                setTimeout(() => {
                    onHide();
                }, 1500);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Erreur réseau. Veuillez réessayer.", "danger");
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setFormData({
            nom: '',
            description: '',
            type_groupe: 'Cohorte',
            nbre_apprenant: 0,
            specialite_id: '',      // ⬅ AJOUT
        });
    };

    const handleCancel = () => {
        resetForm();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title className="d-flex align-items-center">
                    <BsPeople size={25} className='mr-2' /> Nouveau Groupe
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="">
                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="form-group">
                            <label>Nom*</label>
                            <input
                                type="text"
                                className="form-control"
                                required
                                name="nom"
                                value={formData.nom}
                                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Description</label>
                            <input
                                type="text"
                                className="form-control"
                                name="description"
                                value={formData.description || ''}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            />
                        </div>

                        <div className="form-group">
                            <label>Type du groupe*</label>
                            <select
                                className="form-control m-b"
                                name="type_groupe"
                                value={formData.type_groupe}
                                onChange={(e) => setFormData({ ...formData, type_groupe: e.target.value })}
                            >
                                <option value="Cohorte">Cohorte</option>
                                <option value="Groupe système">Groupe système</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Nombre d'apprenant prévu*</label>
                            <input
                                type="number"
                                className="form-control"
                                required
                                name="nbre_apprenant"
                                value={formData.nbre_apprenant || ''}
                                onChange={(e) => setFormData({ ...formData, nbre_apprenant: e.target.value })}
                            />
                        </div>

                        {/* ============ SPÉCIALITÉ (obligatoire) ============ */}
                        <div className="form-group">
                            <label>
                                Spécialité du groupe <span className="text-danger">*</span>
                            </label>
                            <select
                                className="form-control"
                                name="specialite_id"
                                required
                                value={formData.specialite_id}
                                onChange={(e) => setFormData({ ...formData, specialite_id: e.target.value })}
                                disabled={isLoadingSpecialites}
                            >
                                <option value="">
                                    {isLoadingSpecialites
                                        ? 'Chargement des produits...'
                                        : 'Sélectionner un produit'}
                                </option>
                                {specialites.map((spec) => (
                                    <option key={spec.id} value={spec.id}>
                                        {spec.titre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="text-center mt-5">
                            <button
                                type="button"
                                className="btn btn-default mr-2"
                                onClick={() => {
                                    resetForm();
                                    onHide();
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                type="button"
                                className="btn btn-default mr-2"
                                onClick={handleCancel}
                            >
                                Effacer
                            </button>
                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

const Liste_groupe = ({ titre }) => {
    useAuth()
    const existingAcces = { acces: [] };
    const [parcours, setParcours] = useState([]);
    const [groupes, setGroupes] = useState([]);
    const [selectedGroupe, setSelectedGroupe] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddGroupeModal, setShowAddGroupeModal] = useState(false); // Nouvel état pour le modal d'ajout
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [groupeAcces, setGroupeAcces] = useState(null);
    const [expandedGroupeIds, setExpandedGroupeIds] = useState([]);
    const [groupeDescriptionOverflows, setGroupeDescriptionOverflows] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = groupes.length;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    const [userData, setUserData] = useState([]);

    useEffect(() => {
        setLoading(true)
        const fetchUserData = async () => {
            try {

                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
                    method: 'get',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                console.log(data)
                setLoading(false)
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
                setLoading(false)
            }
            setLoading(false)
        };

        fetchUserData();
    }, [user_id]);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Groupe";
        }
    }, [user_id]);

    const fetchGroupes = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/liste-groupes/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupes(data);
                setIsLoading(false)
            } else {
                console.error('Erreur lors de la récupération des groupes');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {
        fetchGroupes();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchGroupes()
        }, 3000);
    };

    const handleRowClick = (groupe) => {
        setSelectedGroupe(groupe);
    };

    const handleDeleteGroupe = async () => {
        if (selectedGroupe) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-groupe/${selectedGroupe.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setGroupes(groupes.filter((groupe) => groupe.id !== selectedGroupe.id));
                    setSelectedGroupe(null);
                    showAlert('Groupe supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression du groupe');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleCloseModal = () => setShowModal(false);

    const handleAccesChange = async (accesString) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/enregistrer-acces-groupe/${selectedGroupe.id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ acces: accesString }),
            });

            if (response.ok) {
                const responseData = await response.json();
                console.log('Accès enregistrés avec succès:', responseData);
                showAlert('Accès enregistrés avec succès !');
                setGroupeAcces(responseData);
                setShowModal(false);
            } else {
                const errorData = await response.json();
                console.error('Erreur lors de l\'enregistrement des accès:', errorData);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeAcces = async (groupeId) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-acces/${groupeId}/`);
            if (response.ok) {
                const data = await response.json();
                setGroupeAcces(data);
                console.log("Acces :", data.acces)
            } else {
                console.error('Erreur lors de la récupération des accès du groupe');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const filteredGroupes = groupes.filter(groupe =>
        (groupe.nom || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (groupe.description || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (groupe.type_groupe || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (groupe.nombre_utilisateurs || '').toString().includes(searchTerm.toLowerCase()) ||
        (groupe.ajoute_par || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (groupe.specialite_titre || '').toLowerCase().includes(searchTerm.toLowerCase())  // ⬅ AJOUT
    );

    const sortedGroupes = [...filteredGroupes].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    // Pagination logic
    const indexOfLastGroupe = currentPage * itemsPerPage;
    const indexOfFirstGroupe = indexOfLastGroupe - itemsPerPage;
    const currentGroupes = sortedGroupes.slice(indexOfFirstGroupe, indexOfLastGroupe);
    const totalPages = Math.ceil(sortedGroupes.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleToggleDescription = (id) => {
        console.log("Toggling description for ID:", id);
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkGroupeDescriptionOverflow = (groupes) => {
        groupes.forEach((groupe) => {
            const element = document.getElementById(`groupe-description-${groupe.id}`);
            if (element) {
                setGroupeDescriptionOverflows((prev) => ({
                    ...prev,
                    [groupe.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkGroupeDescriptionOverflow(groupes);
    }, [groupes]);

    const handleConfigurer = (groupe) => {
        if (groupe) {
            navigate(`/Configurer-groupe`, {
                state: { groupe_id: groupe.id },
            });
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    const handleAddGroupeSuccess = () => {
        fetchGroupes(); // Rafraîchir la liste des groupes
        showAlert("Groupe créé avec succès !", "success");
    };

    if (!accesGroupe.includes("Groupes")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' /> Gestion des groupes</h2>
                            <small>Administration des groupes d'utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}> Groupes</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                <h5>Liste des groupes</h5>

                                <div className="d-flex flex-column flex-md-row mt-3 mt-md-0">
                                    <div className="row">

                                        {loading ? (
                                            ""
                                        ) : !userData?.coach_groupe && (
                                            <button
                                                onClick={() => setShowAddGroupeModal(true)}
                                                className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1"
                                            >
                                                <FaPlus />
                                                <span className="d-none d-sm-inline ml-2">
                                                    Créer un groupe
                                                </span>
                                            </button>
                                        )}

                                        <button
                                            onClick={() => handleConfigurer(selectedGroupe)}
                                            className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedGroupe ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedGroupe}
                                        >
                                            <FaCogs />
                                            <span className="d-none d-sm-inline ml-2">
                                                Configuration
                                            </span>
                                        </button>

                                        {loading ? (
                                            ""
                                        ) : !userData?.coach_groupe && (
                                            <button
                                                onClick={() => handleShowDeleteModal(selectedGroupe)}
                                                className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedGroupe ? 'btn-success' : 'btn-default text-dark'}`}
                                                disabled={!selectedGroupe}
                                            >
                                                <FaTrash />
                                                <span className="d-none d-sm-inline ml-2">
                                                    Supprimer
                                                </span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom{sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('description')}>Description {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('nbre')}>Nbre d'utilisateurs {sortConfig.key === 'nbre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('ajoute_par')}>Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('type_groupe')}>Type {sortConfig.key === 'type_groupe'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell text-center' onClick={() => handleSort('specialite_titre')}>Produit {sortConfig.key === 'specialite_titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            currentGroupes.map((groupe) => {
                                                                const isExpanded = expandedDescriptions[groupe.id];
                                                                return (
                                                                    <tr
                                                                        key={groupe.id}
                                                                        onClick={() => handleRowClick(groupe)}
                                                                        className={`bg-white ${selectedGroupe && selectedGroupe.id === groupe.id ? 'bg-success text-white' : ''}`}
                                                                    >
                                                                        <td>
                                                                            {groupe.nom}
                                                                            <div className='lesInfos'>
                                                                                <small>Description :
                                                                                    <div
                                                                                        id={`groupe-description-${groupe.id}`}
                                                                                        className={`description-text ${expandedDescriptions[groupe.id] ? 'expanded' : ''}`}
                                                                                        style={{ maxHeight: expandedDescriptions[groupe.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                                    >
                                                                                        {groupe.description ? (
                                                                                            <span dangerouslySetInnerHTML={{ __html: groupe.description }}></span>
                                                                                        ) : (
                                                                                            <em>Non défini</em>
                                                                                        )}
                                                                                    </div>
                                                                                    {groupe.description && groupeDescriptionOverflows[groupe.id] && (
                                                                                        <button
                                                                                            onClick={() => handleToggleDescription(groupe.id)}
                                                                                            style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                        >
                                                                                            {expandedDescriptions[groupe.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                        </button>
                                                                                    )}
                                                                                </small>
                                                                                <small>Ajouté par : {groupe.ajoute_par}</small><br />
                                                                                <small>Statut : {groupe.type_groupe}</small>
                                                                                <small>Spécialité : {groupe.specialite_titre || 'Non définie'}</small>
                                                                            </div>
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell" style={{ position: 'relative' }}>
                                                                            <div
                                                                                id={`groupe-description-${groupe.id}`}
                                                                                className={`description-text ${expandedDescriptions[groupe.id] ? 'expanded' : ''}`}
                                                                                style={{ maxHeight: expandedDescriptions[groupe.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                            >
                                                                                {groupe.description ? (
                                                                                    <span dangerouslySetInnerHTML={{ __html: groupe.description }}></span>
                                                                                ) : (
                                                                                    <em>Non défini</em>
                                                                                )}
                                                                            </div>
                                                                            {groupe.description && groupeDescriptionOverflows[groupe.id] && (
                                                                                <button
                                                                                    onClick={() => handleToggleDescription(groupe.id)}
                                                                                    style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                >
                                                                                    {expandedDescriptions[groupe.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                        <td className="d-none d-md-table-cell text-center">{groupe.nombre_utilisateurs}/{groupe.nbre_apprenant || groupe.nombre_utilisateurs}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{groupe.ajoute_par}</td>
                                                                        <td className="d-none d-md-table-cell text-center">{groupe.type_groupe}</td>
                                                                        {/* ============ SPÉCIALITÉ ============ */}
                                                                        <td className="d-none d-md-table-cell text-center">{groupe.specialite_titre ? (
                                                                            <span className="badge bg-success text-white">
                                                                                {groupe.specialite_titre}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-muted">—</span>
                                                                        )}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mt-2">Chargement des groupes...</div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstGroupe + 1} à ${Math.min(indexOfLastGroupe, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal pour ajouter un groupe */}
                    <AjouterGroupeModal
                        show={showAddGroupeModal}
                        onHide={() => setShowAddGroupeModal(false)}
                        onSuccess={handleAddGroupeSuccess}
                        userId={user_id}
                    />

                    <Ajouter_acces
                        show={showModal}
                        handleClose={handleCloseModal}
                        onAccesChange={handleAccesChange}
                        liste_groupe={groupeAcces || []}
                    />

                    {/* Modal de confirmation de suppression */}
                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la Suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer le groupe <strong>{selectedGroupe?.nom}</strong> ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDeleteGroupe}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>

            <style jsx>{`
                width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                word-wrap: break-word;
                overflow-wrap: break-word;
                white-space: normal;
            `}</style>
        </div>
    );
};

export default Liste_groupe;